import {useCallback} from 'react';
import {useHistory} from 'react-router';
import urlcat from 'urlcat';

import { useApplicationRootUrl } from 'common/component/ApplicationRootContext';


type Args = {
    referralGuid?: string;
}

export function useGoToNewOfferPageIfPossible(args: Args) {
    const history = useHistory();
    const rootUrl = useApplicationRootUrl();

    const {referralGuid} = args;

    return useCallback(
        () => {
            if (referralGuid) {
                const url = urlcat(rootUrl + '/offer/new', {
                    referralGuid,
                });
                history.push(url);
            }
        },
        [history, referralGuid , rootUrl]
    );
}
